















































import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwModal, SwModalBody, SwModalFooter } from '@libs-uuif/shared/sw-modal';
import { Component, Prop } from 'vue-property-decorator';

const cssPrefix = 'free-trial-update';

@Component({
  name: 'FreeTrialUpdateModal',
  components: {
    SwButton,
    SwModal,
    SwModalBody,
    SwModalFooter,
  },
})
export default class FreeTrialUpdateModal extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ type: Boolean, default: false })
  isModalOpen: boolean;
  @Prop()
  upgradeConfirmationObject: any;
}
